import { createAction } from '@reduxjs/toolkit';
import {
	GetAllFailureDefinitionsResolvedPayload,
	GetAllDeteriorationModelsResolvedPayload,
} from '@Types/pipeDeterioration.types';

export const getFailureDefinitions = createAction(
	'pipeDeterioration/getFailureDefinitions',
);
export const getFailureDefinitionsResolved =
	createAction<GetAllFailureDefinitionsResolvedPayload>(
		'pipeDeterioration/getFailureDefinitionsResolved',
	);
export const getFailureDefinitionsRejected = createAction(
	'pipeDeterioration/getFailureDefinitionsRejected',
);

export const getDeteriorationModels = createAction(
	'pipeDeterioration/getDeteriorationModels',
);
export const getDeteriorationModelsResolved =
	createAction<GetAllDeteriorationModelsResolvedPayload>(
		'pipeDeterioration/getDeteriorationModelsResolved',
	);
export const getDeteriorationModelsRejected = createAction(
	'pipeDeterioration/getDeteriorationModelsRejected',
);
